import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  isSidebarActive: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() { }
}
